import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import './PcbView.scss'
import TestForm from '../../../components/TestForm'
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'

class PcbView extends React.Component {
  static defaultProps = {
    device: {
      device_string: ''
    },
    params: {},
    runLinacMoveTest: _.noop,
    runMotorTest: _.noop,
    runLedTest: _.noop,
    refreshDeviceData: _.noop,
    pushTestData: _.noop
  }

  static propTypes = {
    device: PropTypes.shape({
      device_string: PropTypes.string
    }),
    params: PropTypes.shape({}),
    runLinacMoveTest: PropTypes.func,
    runMotorTest: PropTypes.func,
    runLedTest: PropTypes.func,
    refreshDeviceData: PropTypes.func,
    pushTestData: PropTypes.func,
    router: PropTypes.shape({
      push: PropTypes.func
    })
  }

  constructor (props) {
    super(props)
    const { device_string } = props.params
    const { device } = props

    this.state = {
      loading: false,
      testGroups: [
        {
          key: 'pcb',
          title: 'Test a PCB',
          tests: [
            {
              step: 'Linear Actuator',
              manualStart: true,
              startTest: (e) => props.runLinacMoveTest(device_string) && e.preventDefault(),
              inputs: [
                {
                  key: 'test_linac_moves',
                  type: 'checkbox',
                  prompt: 'Does the linear actuator move outwards and inwards?',
                  readOnly: false,
                  value: _.get(device, 'data.unit_test_results.pcb.test_linac_moves')
                }
              ]
            },
            {
              step: 'Motor',
              manualStart: true,
              startTest: (e) => props.runMotorTest(device_string) && e.preventDefault(),
              inputs: [
                {
                  key: 'test_motor',
                  type: 'checkbox',
                  prompt: 'Does the motor rotate in one direction?',
                  readOnly: false,
                  value: _.get(device, 'data.unit_test_results.pcb.test_motor')
                },
                {
                  key: 'test_switch',
                  type: 'checkbox',
                  prompt: 'Does the motor stop rotating when you hit the switch?',
                  readOnly: false,
                  value: _.get(device, 'data.unit_test_results.pcb.test_switch')
                }
              ]
            },
            {
              step: 'LED',
              manualStart: true,
              startTest: (e) => props.runLedTest(device_string) && e.preventDefault(),
              inputs: [
                {
                  key: 'test_led_rgb',
                  type: 'checkbox',
                  prompt: 'Do 3 LEDs turn on evenly under the tape?',
                  readOnly: false,
                  value: _.get(device, 'data.unit_test_results.pcb.test_led_rgb')
                }
              ]
            },
            {
              step: 'Cover the Proximity Sensor with your hand.',
              manualStart: false,
              inputs: [
                {
                  key: 'test_proximity_sensor',
                  type: 'checkbox',
                  prompt: 'Does a light appear when you cover the IR sensor?',
                  readOnly: false,
                  value: _.get(device, 'data.unit_test_results.pcb.test_proximity_sensor')
                }
              ]
            }
          ]
        },
        {
          key: 'confirmation',
          title: 'Confirmation',
          tests: [
            {
              step: 'Confirm final information',
              manualStart: false,
              inputs: [
                {
                  key: 'serial_number',
                  type: 'text',
                  placeholder: 'Enter Board Serial Number',
                  value: _.get(device, 'data.unit_test_results.confirmation.serial_number')
                },
                {
                  key: 'confirm_operator_initials',
                  type: 'text',
                  prompt: 'Operator Initials',
                  placeholder: 'Operator Initials',
                  value: _.get(device, 'data.unit_test_results.confirmation.confirm_operator_initials')
                }
              ]
            }
          ]
        }
      ]
    }
  }

  componentWillReceiveProps (nextProps) {
    const { device } = nextProps
    const { testGroups } = this.state
    _.forEach(testGroups, (group) => {
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (check) => {
          if (_.isNull(check.value) || _.isUndefined(check.value)) {
            check.value = _.get(device, ['data', 'unit_test_results', group.key, check.key], false)
          }
        })
      })
    })
    this.setState({
      testGroups
    })
  }

  componentDidMount () {
    const { device, refreshDeviceData, params } = this.props
    const { device_string } = params
    if (!device.data) {
      refreshDeviceData(device_string)
    }
  }

  setValue = (key, value) => {
    const { testGroups } = this.state
    _.forEach(testGroups, (group) => {
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (input) => {
          if (input.key === key) {
            input.value = value
          }
        })
      })
    })
    this.setState({ testGroups })
  }

  submitTestData = (event) => {
    event.preventDefault()
    const { testGroups } = this.state
    const { params, pushTestData, router } = this.props
    const testResults = {}
    _.forEach(testGroups, (group) => {
      testResults[group.key] = {}
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (check) => {
          testResults[group.key][check.key] = check.value
        })
      })
    })
    var date = new Date()
    var utcDate = new Date(date.toUTCString())
    utcDate.setHours(utcDate.getHours() - 8)
    var usDate = new Date(utcDate).toJSON().slice(0, 10).replace(/-/g, '-')
    var filename = `PCB-${usDate}-${testResults['confirmation']['serial_number']}.pdf`

     html2canvas(document.body).then( (canvas) => {
      document.body.appendChild(canvas)
      const link = document.getElementById('downloadLink')
      var data = document.getElementsByTagName('canvas')[0].toDataURL('image/jpeg')
      link.setAttribute('href', data)
      link.click()  
      })
      .then(() => {
      router.push('/')
      })
    }

  

  clearTestData = (event) => {
    event.preventDefault()
    const { testGroups } = this.state
    _.forEach(testGroups, (group) => {
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (input) => {
          if (input.type === 'checkbox') {
            input.value = false
          } else {
            input.value = ''
          }
        })
      })
    })
    this.setState({
      testGroups
    })
  }

  render () {
    const { loading, testGroups } = this.state
    const { device } = this.props

    return (
      <TestForm
        setValue={this.setValue}
        clearTestData={this.clearTestData}
        submitTestData={this.submitTestData}
        loading={loading}
        testGroups={testGroups}
        gridImageUrl={_.get(device, 'data.unit_test_results.autofocus.autofocus_image_url')}
        barcodeValue={null}
      />
    )
  }
}

export default PcbView



// WEBPACK FOOTER //
// ./src/routes/PCB/components/PcbView.js